import { render, staticRenderFns } from "./formsConfiguration.vue?vue&type=template&id=40dceae9&"
import script from "./formsConfiguration.vue?vue&type=script&lang=js&"
export * from "./formsConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports